import { useRef, useState } from "react";
import Footer from "../components/Footer";
import { useAppContext } from "../../../context";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { apiUrl, appUrl } from "../../../utils/config";

export const Checkout = ({ user  }) => {
  const { cart, addOrder, cartTotal, clearCart, formatPrice, billId } = useAppContext();
  const navigate = useNavigate()
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({ name:user?.name, email:user?.email, phone:user?.phone, address:user?.address, city:"Hyderabad", zip:"500034", notes:"", payment:"card", cardNo:"", expiry:"", cvv:"", upi:"", slot:"now" });
  const h = e => setForm(p => ({...p, [e.target.name]:e.target.value}));
  const del = cartTotal>30?0:3.99;
  const tax = cartTotal*.1;
  const total = cartTotal+del+tax;

  const orderId = useRef("GF"+Math.floor(30000+Math.random()*60000));

   const payNow  = async () => {
       // Create order by calling the server endpoint
 if(!window.Razorpay){
   alert("Razorpay  failed to load. Are you online?");
        return ;
      }
       try {
         const res = await axios.post(`${apiUrl}/payment/pay`, {order_id:2});
        if(res.data && res.data.status && res.data.order){
 // Open Razorpay Checkout
      const options = {
        key: 'rzp_test_SUV1WfanMryRRc', // Replace with your Razorpay key_id
        amount: res.data.order.amount,
        currency: res.data.order.currency,
        name: 'GAMAPA GLOBAL PVT LTD',
        description: '',
        order_id: res.data.order.id, // This is the order_id created in the backend
        callback_url: appUrl+'/payment-success', // Your success URL
        prefill: {
          name: 'Your Name',
          email: 'your.email@example.com',
          contact: '9999999999'
        },
        theme: {
          color: '#F37254'
        },
        handler: function (response) {
          console.log("after payment",response)
          fetch(apiUrl+'/payment/verify', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature
            })
          }).then(res => res.json())
            .then(data => {
              if (data.status === 'ok') {

                //window.location.href = '/payment-success';
                   clearCart();
    setStep(4);
    alert("Order placed successfully! 🎉 Estimated delivery: 30 min","success");
 
              } else {
                alert('Payment verification failed');
              }
            }).catch(error => {
              console.error('Error:', error);
              alert('Error verifying payment');
            });
        }
      };
     
      const rzp = new window.Razorpay(options);
       rzp.open();
      
    
        }
       } catch (error) {
        console.log(error)
       }
      
    
  }

  const place = () => {
    if(form.payment == "cod"){
                 clearCart();
    setStep(4);
    alert("Order placed successfully! 🎉 Estimated delivery: 30 min","success");
 
    }else{
       payNow()
    }
   
  };

  const inputCls = "w-full px-4 py-3 border border-gray-200 rounded-xl text-sm bg-white transition-colors";

  if (step===4) return (
    <div className="max-w-lg mx-auto px-4 py-24 text-center afu">
      <div className="w-24 h-24 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-2xl shadow-green-200 text-5xl">✓</div>
      <h2 className="font-serif text-4xl text-gray-900 mb-2">Order Confirmed! 🎉</h2>
      <p className="text-gray-500 mb-1">Your order is being prepared with love.</p>
      <p className="text-2xl font-black text-[#f97316] mb-1">{orderId.current}</p>
      <p className="text-sm text-gray-400 mb-4">Estimated delivery: <strong>25–35 minutes</strong></p>
      <div className="bg-orange-50 rounded-2xl p-5 border border-orange-100 mb-8 text-left">
        <div className="flex items-center gap-2 text-sm text-gray-600 mb-2"><span>📍</span><span>{form.address}</span></div>
        <div className="flex items-center gap-2 text-sm text-gray-600 mb-2"><span>💰</span><span>Paid {formatPrice(total)} via {form.payment==="card"?"Card":form.payment==="upi"?"UPI":"Cash on Delivery"}</span></div>
        <div className="flex items-center gap-2 text-sm text-gray-600"><span>📱</span><span>SMS updates to {form.phone}</span></div>
      </div>
      <div className="flex gap-3 justify-center">
        <button onClick={() => navigate(billId ? `/track/${billId}` : "/track")} className="border border-[#f97316] text-[#f97316] font-bold px-6 py-3 rounded-xl btn-press hover:bg-orange-50">Track Order</button>
        <button onClick={() => navigate("/")} className="bg-[#f97316] text-white font-bold px-6 py-3 rounded-xl btn-press hover:bg-orange-600">Back to Home</button>
      </div>
    </div>
  );



  return (<>
    <div className="max-w-5xl mx-auto px-4 py-10">
      <h1 className="font-serif text-4xl text-gray-900 mb-8">Checkout</h1>

      {/* Steps */}
      <div className="flex items-center mb-8">
        {[{n:1,l:"Delivery"},{n:2,l:"Payment"},{n:3,l:"Review"}].map((s,i) => (
          <div key={s.n} className="flex items-center flex-1 last:flex-none">
            <div className={`flex items-center gap-2 ${step===s.n?"text-[#f97316]":step>s.n?"text-green-500":"text-gray-300"}`}>
              <div className={`w-9 h-9 rounded-full flex items-center justify-center font-black text-sm border-2 transition-all ${step>s.n?"border-green-500 bg-green-500 text-white":step===s.n?"border-[#f97316] text-[#f97316]":"border-gray-200 text-gray-300"}`}>
                {step>s.n?"✓":s.n}
              </div>
              <span className={`font-semibold text-sm hidden sm:block ${step===s.n?"text-[#f97316]":step>s.n?"text-green-500":"text-gray-400"}`}>{s.l}</span>
            </div>
            {i<2 && <div className={`flex-1 h-0.5 mx-3 transition-all ${step>s.n?"bg-green-400":"bg-gray-100"}`}/>}
          </div>
        ))}
      </div>

      <div className="grid md:grid-cols-3 gap-8">
        <div className="md:col-span-2">
          {step===1 && (
            <div className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm space-y-4">
              <h3 className="font-bold text-gray-900 text-lg">Delivery Details</h3>
              <div className="grid grid-cols-2 gap-4">
                <div><label className="text-xs font-bold text-gray-600 mb-1 block">Full Name *</label><input name="name" value={form.name} onChange={h} placeholder="Your name" className={inputCls}/></div>
                <div><label className="text-xs font-bold text-gray-600 mb-1 block">Phone *</label><input name="phone" value={form.phone} onChange={h} placeholder="+91 98765..." className={inputCls}/></div>
              </div>
              <div><label className="text-xs font-bold text-gray-600 mb-1 block">Email</label><input name="email" value={form.email} onChange={h} type="email" placeholder="email@example.com" className={inputCls}/></div>
              <div><label className="text-xs font-bold text-gray-600 mb-1 block">Delivery Address *</label><input name="address" value={form.address} onChange={h} placeholder="Street, Building, Flat" className={inputCls}/></div>
              <div className="grid grid-cols-2 gap-4">
                <div><label className="text-xs font-bold text-gray-600 mb-1 block">City</label><input name="city" value={form.city} onChange={h} className={inputCls}/></div>
                <div><label className="text-xs font-bold text-gray-600 mb-1 block">PIN Code</label><input name="zip" value={form.zip} onChange={h} className={inputCls}/></div>
              </div>
              <div><label className="text-xs font-bold text-gray-600 mb-1 block">Delivery Time</label>
                <select name="slot" value={form.slot} onChange={h} className={inputCls}>
                  <option value="now">ASAP (25–35 min)</option>
                  <option value="1h">In 1 Hour</option>
                  <option value="2h">In 2 Hours</option>
                  <option value="tomorrow_morning">Tomorrow Morning (8–10 AM)</option>
                  <option value="tomorrow_lunch">Tomorrow Lunch (12–2 PM)</option>
                </select>
              </div>
              <div><label className="text-xs font-bold text-gray-600 mb-1 block">Delivery Notes</label><textarea name="notes" value={form.notes} onChange={h} rows={2} placeholder="Gate code, landmarks, parking notes..." className={inputCls+" resize-none"}/></div>
              <button onClick={() => setStep(2)} className="w-full bg-gradient-to-r from-[#f97316] to-red-500 text-white font-black py-4 rounded-xl btn-press hover:shadow-lg hover:shadow-orange-200">Continue to Payment →</button>
            </div>
          )}

          {step===2 && (
            <div className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm space-y-4">
              <h3 className="font-bold text-gray-900 text-lg">Payment Method</h3>
              <div className="grid grid-cols-3 gap-3">
                {[["online","💳","Online"],["cod","💵","Cash"]].map(([pm,ic,lb]) => (
                  <button key={pm} onClick={() => setForm(p=>({...p,payment:pm}))}
                    className={`flex flex-col items-center gap-1.5 py-4 rounded-xl border-2 font-semibold text-sm transition-all btn-press ${form.payment===pm?"border-[#f97316] bg-orange-50 text-[#f97316]":"border-gray-200 text-gray-500 hover:border-orange-200"}`}>
                    <span className="text-xl">{ic}</span>{lb}
                  </button>
                ))}
              </div>
             { /* <div className="grid grid-cols-3 gap-3">
                {[["card","💳","Card"],["upi","📱","UPI"],["cod","💵","Cash"]].map(([pm,ic,lb]) => (
                  <button key={pm} onClick={() => setForm(p=>({...p,payment:pm}))}
                    className={`flex flex-col items-center gap-1.5 py-4 rounded-xl border-2 font-semibold text-sm transition-all btn-press ${form.payment===pm?"border-[#f97316] bg-orange-50 text-[#f97316]":"border-gray-200 text-gray-500 hover:border-orange-200"}`}>
                    <span className="text-xl">{ic}</span>{lb}
                  </button>
                ))}
              </div>
              {form.payment==="card" && (
                <div className="space-y-3">
                  <div className="bg-gradient-to-r from-gray-800 to-gray-900 rounded-2xl p-5 text-white mb-4">
                    <div className="text-xs text-gray-400 mb-4">Card Number</div>
                    <div className="font-mono text-lg tracking-[.25em] mb-4">{form.cardNo.padEnd(16,"•").replace(/(.{4})/g,"$1 ").trim()}</div>
                    <div className="flex justify-between items-end">
                      <div><div className="text-xs text-gray-400">Cardholder</div><div className="font-semibold text-sm">{form.name||"YOUR NAME"}</div></div>
                      <div><div className="text-xs text-gray-400">Expires</div><div className="font-semibold text-sm">{form.expiry||"MM/YY"}</div></div>
                    </div>
                  </div>
                  <div><label className="text-xs font-bold text-gray-600 mb-1 block">Card Number</label><input name="cardNo" value={form.cardNo} onChange={h} placeholder="1234 5678 9012 3456" maxLength={16} className={inputCls}/></div>
                  <div className="grid grid-cols-2 gap-3">
                    <div><label className="text-xs font-bold text-gray-600 mb-1 block">Expiry Date</label><input name="expiry" value={form.expiry} onChange={h} placeholder="MM/YY" className={inputCls}/></div>
                    <div><label className="text-xs font-bold text-gray-600 mb-1 block">CVV</label><input name="cvv" value={form.cvv} onChange={h} placeholder="•••" type="password" maxLength={3} className={inputCls}/></div>
                  </div>
                </div>
              )}
              {form.payment==="upi" && (
                <div><label className="text-xs font-bold text-gray-600 mb-1 block">UPI ID</label><input name="upi" value={form.upi} onChange={h} placeholder="yourname@paytm" className={inputCls}/>
                  <div className="flex gap-3 mt-3">
                    {["gpay","phonepe","paytm","bhim"].map(a => <span key={a} className="text-xs bg-gray-100 px-3 py-1.5 rounded-lg font-medium text-gray-600">{a}</span>)}
                  </div>
                </div>
              )} */}
            
              {form.payment==="cod" && <div className="bg-amber-50 border border-amber-200 rounded-xl p-4"><p className="text-sm text-amber-700 font-medium">💵 Cash on delivery selected. Please keep exact change of <strong>{formatPrice(total)}</strong> ready.</p></div>}
              <div className="flex gap-3 pt-2">
                <button onClick={() => setStep(1)} className="flex-1 border border-gray-200 text-gray-600 font-semibold py-3.5 rounded-xl hover:bg-gray-50 btn-press">← Back</button>
                <button onClick={() => setStep(3)} className="flex-[2] bg-gradient-to-r from-[#f97316] to-red-500 text-white font-black py-3.5 rounded-xl btn-press hover:shadow-lg hover:shadow-orange-200">Review Order →</button>
              </div>
            </div>
          )}

          {step===3 && (
            <div className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm space-y-5">
              <h3 className="font-bold text-gray-900 text-lg">Review Your Order</h3>
              <div className="bg-gray-50 rounded-xl p-4 space-y-1 text-sm">
                <div className="flex items-center gap-2 text-gray-700"><span>📝</span><span>{form.name + " "}{form.email}</span></div>
                <div className="flex items-center gap-2 text-gray-700"><span>📍</span><span className="font-medium">{form.address}, {form.city} {form.zip}</span></div>
                <div className="flex items-center gap-2 text-gray-700"><span>📱</span><span>{form.phone}</span></div>
                { /* <div className="flex items-center gap-2 text-gray-700"><span>💰</span><span className="font-bold">{form.payment==="online"?"Card ending "+form.cardNo.slice(-4):form.payment==="upi"?"UPI: "+form.upi:"Cash on Delivery"}</span></div> */ }
                <div className="flex items-center gap-2 text-gray-700"><span>💰</span><span className="font-bold">{form.payment == "online"?"Online":"Cash on Delivery"}</span></div>
                {form.slot!=="now" && <div className="flex items-center gap-2 text-gray-700"><span>🕐</span><span>Scheduled: {form.slot}</span></div>}
              </div>
              <div className="space-y-2 max-h-48 overflow-y-auto thin-scroll">
                {cart.map(i => (
                  <div key={i.id} className="flex items-center gap-3 text-sm">
                    <img src={i?.images?.image} alt={i.name} className="w-10 h-10 rounded-lg object-cover flex-shrink-0"/>
                    <span className="flex-1 text-gray-700">{i.name ? i.name : "no-name"}</span>
                    <span className="text-gray-400">×{i.quantity}</span>
                    <span className="font-bold text-gray-800">{formatPrice(i.price*i.quantity)}</span>
                  </div>
                ))}
              </div>
              {form.notes && <div className="text-xs text-gray-500 bg-gray-50 rounded-lg p-3">📝 Note: {form.notes}</div>}
              <div className="flex gap-3 pt-2">
                <button onClick={() => setStep(2)} className="flex-1 border border-gray-200 text-gray-600 font-semibold py-3.5 rounded-xl hover:bg-gray-50 btn-press">← Back</button>
                <button onClick={place} className="flex-[2] bg-gradient-to-r from-[#f97316] to-red-500 text-white font-black py-3.5 rounded-xl btn-press hover:shadow-xl hover:shadow-orange-200 text-base">
                  Place Order — {formatPrice(total)} 🎉
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Order Summary Sidebar */}
        <div className="bg-white rounded-2xl p-5 border border-gray-100 shadow-sm h-fit">
          <h3 className="font-bold text-gray-900 mb-4">Your Order</h3>
          <div className="space-y-3 mb-4 max-h-60 overflow-y-auto thin-scroll">
            {cart?.map(i => (
              <div key={i.id} className="flex gap-2.5 items-center">
                <img src={i?.images?.image} alt={i.name} className="w-10 h-10 rounded-xl object-cover flex-shrink-0"/>
                <div className="flex-1 min-w-0"><p className="text-xs font-semibold text-gray-800 truncate">{i.name}</p><p className="text-xs text-gray-400">×{i.quantity}</p></div>
                <span className="text-xs font-black text-gray-700">{formatPrice(i.price*i.quantity)}</span>
              </div>
            ))}
          </div>
          <div className="border-t border-gray-100 pt-3 space-y-1.5 text-sm">
            <div className="flex justify-between text-gray-500"><span>Subtotal</span><span>{formatPrice(cartTotal)}</span></div>
            <div className="flex justify-between text-gray-500"><span>Delivery</span><span className={del===0?"text-green-500 font-bold":""}>{del===0?"FREE":formatPrice(del)}</span></div>
            <div className="flex justify-between text-gray-500"><span>Tax</span><span>{formatPrice(tax)}</span></div>
            <div className="flex justify-between font-black text-gray-900 text-base border-t pt-2"><span>Total</span><span className="text-[#f97316]">{formatPrice(total)}</span></div>
          </div>
        </div>
      </div>
    </div>
      <Footer />
    </>
  );
};